import AlexStates from 'a/components/GameHeader/AlexStates';

import { GAME_ID, ActivityWindowType, LevelStage } from '../../data/constants';

const initialState = {
  alexState: AlexStates.INACTIVE,
  sounds: [],
  playing: false,
};

/**
 * Controls sounds, including playing, stopping, and setting Alex.
 * Works by keeping an array of sounds. New sounds are pushed in,
 * and as long as one of them is tagged as VO (markmy_###), Alex will talk.
 *
 * Quick Refs:
 * PLAY_SOUND
 * SOUND_END
 * STOP_SOUND
 * SET_ALEX_STATE
 */
const soundReducer = (state = initialState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  const sounds = state.sounds.slice();
  const soundDescs = [];
  for (let i = 0; i < sounds.length; ++i) {
    soundDescs.push(sounds[i].desc);
  }

  // If it's not a LEVEL or it's ONBOARDING, AlexStates.ACTIVE
  const isActive =
    state.windowType !== ActivityWindowType.LEVEL ||
    state.stage === LevelStage.ONBOARDING;

  switch (type) {
    case 'PLAY_SOUND':
      sounds.push(payload.audio);
      sounds[sounds.length - 1].play();

      return {
        alexState: isActive ? AlexStates.ACTIVE : AlexStates.INACTIVE,
        sounds,
        playing: true,
      };
    case 'SOUND_END':
      if (soundDescs.indexOf(payload.description) !== -1) {
        sounds.splice(soundDescs.indexOf(payload.description), 1);

        if (sounds.length === 0) {
          return {
            ...state,
            alexState: payload.active ? AlexStates.ACTIVE : AlexStates.INACTIVE,
            sounds,
            playing: false,
          };
        }
      }

      return {
        ...state,
        sounds,
        playing: true,
      };
    case 'STOP_SOUND':
      for (let i = 0; i < sounds.length; ++i) {
        sounds[i].stop();
      }
      return {
        ...state,
        alexState:
          state.stage === LevelStage.ONBOARDING
            ? AlexStates.ACTIVE
            : AlexStates.INACTIVE,
        sounds: [],
        playing: false,
      };
    case 'SET_ALEX_STATE':
      return {
        ...state,
        alexState: payload.alexState,
      };
    case 'COMPLETE_ROUND':
      return {
        ...state,
        playing: false, // needed to prevent accidental re-renders on activityWindow.
      };
    default:
      return state;
  }
};

export default soundReducer;
